import React, { useEffect } from "react";
import arrow from "../images/arrow.svg";
import { dateConversionGlobal, errorToDisplay } from "../../../helper/CommonFuncs";
// import progress from "../images/progress_notes.gif";
import progress from "../../notes-fhir/images/progress_notes.gif";
import LoaderShade from "../../../shared/components/loaderShade/loaderShade";
import { recordingLayerMain } from "../../../redux/actions/note.action";
import { showSwalPopup } from "../../notes-fhir/actions/ShowSwalPopup";
import { fetchMutation } from "../../../actions";
import { CREATE_NOTES_V2, DELETE_CREATE_NOTES, GET_SIGNED_URL_V2 } from "../../notes-fhir/actions/notesAct";
import { uploadmedia } from "../../../Apimanager/Networking";
import deleteDraftButton from "../../notes-fhir/images/delete-drafts.svg";
import { ShowAlert } from "../../../common/alert";

const EpicContent = ({ notesList, setNoteId, loader, getNotes, setStartRecord, patientId, setShowDeletePopup }) => {
   const uploadMediaV2 = (uploadFile, noteId = "", callback = () => {}) => {
      let num = Math.floor(Date.now() / 1000);
      const notesId = noteId;
      const file = "recording-final.m4a";
      localStorage.removeItem("isFinal");
      let notesObj = {
         noteId: notesId,
         fileName: file,
      };
      fetchMutation(GET_SIGNED_URL_V2, notesObj, (res) => {
         const url = res?.data?.getCreateNotesSignedUrl?.signedUrl;
         uploadmedia(url, uploadFile)
            .then(() => {
               localStorage.removeItem("uploadingPending");
               callback();
            })
            .catch((error) => {});
      });
   };

   const deleteNotes = (generateNote) => {
      let notesObj = {
         createNotes: generateNote,
      };

      fetchMutation(
         DELETE_CREATE_NOTES,
         notesObj,
         (res) => {
            getNotes(false);
            const message = res?.data?.createNotes?.status?.message;
            ShowAlert(message);
         },
         (error) => {
            ShowAlert(errorToDisplay(error), "error");
         }
      );
   };

   const UpdatesNoteStatus = (noteId) => {
      let notesObj = {
         createNotesV2: {
            status: "pending",
            id: noteId,
         },
      };
      fetchMutation(CREATE_NOTES_V2, notesObj, (res) => {
         getNotes(false);
      });
   };

   useEffect(() => {
      if (patientId) {
         const timerId = setInterval(() => {
            getNotes(false);
         }, 10000); // 10 seconds

         return () => {
            clearInterval(timerId); // Cleanup the interval when component unmounts
         };
      }
   }, [patientId]);
   return (
      <div className="mt-3 epic-notes-list-container-main">
         {loader ? (
            <div className="mx-3 ml-4">
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
               <LoaderShade classname="epic-list-loaders" />
            </div>
         ) : (
            notesList?.map((item, index) => {
               const getDate = dateConversionGlobal(item?.createdAt);
               const title = item?.title ? item.title : "Notes generation in progress";
               const isPending = item?.status === "pending";
               const isDraft = item?.status === "draft";
               const isRead = item?.isRead;
               return (
                  <div
                     onClick={() => {
                        if (isDraft) {
                           recordingLayerMain(() => {
                              showSwalPopup(
                                 "Draft Note",
                                 "Do you want to continue recording your clinical note?",
                                 "Finish note",
                                 "Finish note",
                                 "Continue",
                                 () => {
                                    localStorage.removeItem("uploadingPending");
                                    localStorage.setItem("isFinal", "true");
                                    uploadMediaV2(new Blob([]), item?.id, () => {
                                       UpdatesNoteStatus(item?.id);
                                    });
                                 },
                                 () => {
                                    const noteIdDraft = item.id;
                                    localStorage.setItem("noteIdCurrent", noteIdDraft);
                                    localStorage.setItem("draftContinue", "true");
                                    setStartRecord(true);
                                 },
                                 false,
                                 false
                              );
                           });
                           localStorage.setItem("noteToContine", item.id);
                           const documents = document.getElementById("recording-continue-epic-new-screen-v2");
                           if (documents) {
                              documents.click();
                           }
                        } else {
                           setNoteId(item.id);
                        }
                     }}
                     className="epic-container-main hover-custom trigger-new-app-v2 "
                  >
                     <div key={item.id} className="epic-content-container">
                        <div
                           className={` ${
                              isDraft ? "content-title-epic-content-draft" : "content-title-epic-content"
                           }  ${!isRead && !isDraft && !isPending && "font-isRead-epic"} `}
                        >
                           {!isRead && !isDraft && !isPending && <div className="dot-blue-epic" />}&nbsp;{title}
                        </div>
                        <div className="time-title-epic-content">
                           <div style={{ marginRight: "10px", display: "inline-block" }}>
                              {isPending ? (
                                 <img src={progress} alt="progress" style={{ width: "24px", height: "24px" }} />
                              ) : (
                                 <>
                                    <img
                                       onClick={(e) => {
                                          setShowDeletePopup(item.id);
                                          e.stopPropagation();
                                       }}
                                       src={deleteDraftButton}
                                       alt="progress "
                                       style={{ width: "14px", height: "14px", marginRight: "10px" }}
                                       className="hidden-div-app-v2-epic pop-in-v2"
                                    />
                                    {getDate}
                                 </>
                              )}
                           </div>
                           <img src={arrow} alt="arrow-right" />
                        </div>
                     </div>
                     {notesList?.length - 1 !== index && <div className="border-bottom-epic" />}
                  </div>
               );
            })
         )}
      </div>
   );
};

export default EpicContent;
